import {afterNextRender, AfterViewInit, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalSettingsService} from '../../../../services/local-settings.service';
import {AuthenticationService} from '../../../../services/authentication.service';
import {UserService} from '../../../../services/user-services/user.service';
import {SchoolService} from '../../../../services/school.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NgClass, NgFor, NgIf, NgTemplateOutlet} from '@angular/common';
import {HubspotService} from '../../../../services/hubspot.service';
import {document} from 'ngx-bootstrap/utils';
import {ProcessService} from '../../../../services/user-services/process.service';
import {finalize, first, take} from 'rxjs/operators';
import {ProcessSharedService} from '../../../../services/process-shared.service';
import * as mapboxgl from 'mapbox-gl';
import {HelperService} from '../../../../services/helper.service';
import {TiktokService} from '../../../../services/tiktok.service';
import {FunctionsUtil} from '../../../../helpers/functions.util';
import {AccommodationMapCardComponent} from '../components/accommodation-map-card/accommodation-map-card.component';
import {ExpandButtonComponent} from '../../../../shared/components/ux/buttons/expand-button/expand-button.component';
import {IconComponent} from '../../../../shared/components/icons-svgs/icons-svgs.component';
import {MapPhComponent} from '../../../../shared/components/ux/preloader-placeholder/map-ph/map-ph.component';
import {LfAdvantagesComponent} from '../../../../shared/components/lf-advantages/lf-advantages.component';
import {AccommodationAlertsComponent} from '../components/accommodation-alerts/accommodation-alerts.component';
import {
  AccommodationListPhComponent
} from '../../../../shared/components/ux/preloader-placeholder/accommodation-list-ph/accommodation-list-ph.component';
import {MatOptionModule} from '@angular/material/core';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {FormsModule} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {ComponentFilterModalComponent} from '../components/component-filter-modal/component-filter-modal.component';
import {AccomFilterPhComponent} from '../../../../shared/components/ux/preloader-placeholder/accom-filter-ph/accom-filter-ph.component';
import {AccommodationCityInputComponent} from '../components/accommodation-city-input/accommodation-city-input.component';
import {
  AccommodationRoomCardComponent
} from '../../../../shared/components/accommodation-specific/accommodation-room-card/accommodation-room-card.component';
import {PlatformService} from '../../../../services/platform-service.service';
import {
  AccomNbAndSortPhComponent
} from '../../../../shared/components/ux/preloader-placeholder/accom-nb-and-sort-ph/accom-nb-and-sort-ph.component';
import {AccommodationService} from '../../../../services/accommodation.service';
import Marker = google.maps.Marker;

@Component({
  selector: 'app-list-layout',
  templateUrl: './list-layout.component.html',
  styleUrls: ['./list-layout.component.scss'],
  standalone: true,
  imports: [NgTemplateOutlet, NgIf, NgFor, AccommodationRoomCardComponent, AccommodationCityInputComponent, AccomFilterPhComponent, ComponentFilterModalComponent, NgClass, MatSelectModule, FormsModule, NgxIntlTelInputModule, MatOptionModule, AccommodationListPhComponent, AccommodationAlertsComponent, LfAdvantagesComponent, MapPhComponent, IconComponent, ExpandButtonComponent, AccommodationMapCardComponent, TranslateModule, AccomNbAndSortPhComponent]
})
export class ListLayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  public locale: string;
  public isMobile = false;

  public school: any;
  public selectedStartingElement: any;
  public currentUser: any;
  public loading: boolean = true;
  // Nombre de properties au total - voire si on peut mettre allRooms.length à la place, ça sert qu'au display
  public countProperties: any;
  // Récupère toutes les chambres/maisons de la ville, peu importe les filtres
  public allRooms: any;
  // Récupère les chambres, toutes si pas de filtres, celles qui match si filtres
  public rooms: any[] = [];
  // Les chambres affichées qui sont update à mesure du scroll ; dépendent de rooms
  public displayedRooms: any[] = [];

  public searchElement = 'lille';
  public urlPrefix: string;
  // map
  public center;
  public options;
  public geoJson;
  public tempMarkers = [];
  public schoolMarker: any = {position: {lat: 0, lng: 0}, options: {icon: 'assets/img/school.png'}};
  public interestMarker: any = {position: {lat: 0, lng: 0}};
  public currentIMarker = null;
  public clickedRoomId: number;
  public currentDisplayedMarker: Marker;
  public isMapToggle = false;
  public hasBeenClicked: number[] = [];
  // scroll event
  public scrollDirection: 'top' | 'down' = 'top';
  public favList: any[] = [];
  public sort = 'none';
  public changedCity = false;
  public startingCities: any[] = [];
  public startingSchools: any[] = [];
  public filters = {ids: []};
  public map: mapboxgl.Map;
  public style = 'mapbox://styles/mapbox/streets-v12?optimize=true';
  public draw;
  public activeCard = null;
  public isMapOnly: boolean = false;

  protected event;
  private currentScroll: number = 0;
  private sideBar;
  private forceCity = false;
  private process;
  private document;
  public innerWidth: number;
  public searchFrom = 'searchbar';
  public isSearchOnMove = false;
  public isMove = false;
  public loadedOnce: boolean = false;
  public search;
  public filterFormModale;
  public hasBadge;

  // Used when no rooms fit the filters
  public noFilteredRooms: any[] = [];
  private _zoomLevel;
  private _maxMarkers;
  private markersOnMap;
  // Récupère toutes les subscriptions pour unsub
  private _subs$ = [];
  private isBrowser;
  public sortList: { id: number, key: string, value: string }[] = [
    {id: 1, key: 'SORT_BY', value: 'none'},
    {id: 2, key: 'PRICE_ASC', value: 'priceAsc'},
    {id: 3, key: 'PRICE_DESC', value: 'priceDesc'},
    {id: 4, key: 'NEWEST', value: 'newest'},
    {id: 5, key: 'DISPONIBILITY_CLOSE', value: 'disponibility_close'},
    {id: 6, key: 'DISPONIBILITY_FAR', value: 'disponibility_far'},
    {id: 7, key: 'FILTER_PROMOTION', value: 'promotion'},
  ];
  public headerHeight: number = 107;
  currentLanguage: string;

  constructor(
    private schoolService: SchoolService,
    private helperService: HelperService,
    private userService: UserService,
    private _translateService: TranslateService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router,
    private _localSettings: LocalSettingsService,
    private hubspotService: HubspotService,
    private processService: ProcessService,
    private sharedProcessService: ProcessSharedService,
    private tikTokService: TiktokService,
    private platformService: PlatformService,
    private accommodationService: AccommodationService
  ) {
    this.isBrowser = this.platformService.isBrowserPlatform();
    afterNextRender(() => {
      this.event = event;

      if (this.route.snapshot.firstChild) {
        this.forceCity = true;
        const input = this.route.snapshot.firstChild.paramMap.get('city');
        if (this.helperService.isValidInput(input) === true) {
          this.searchElement = this.helperService.slugify(input);
        } else {
          this.searchElement = 'Lille';
          this.router.navigate(['/' +this.locale+'/accommodation/list/' + this.helperService.slugify(this.searchElement)], {
            relativeTo: this.route,
            replaceUrl: true
          });
        }
      }
    });
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.platformService.isBrowserPlatform()) {
      this.innerWidth = window.innerWidth;
    }
    this.addScrollListener();
  }

  ngOnInit(): void {

    this._localSettings.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );

    if (this.isBrowser) {
      this.innerWidth = window.innerWidth;
      this.isMobile = this.userService.isMobileUser;
      this.locale = this._translateService.currentLang;
      this.route.data.subscribe((d) => {
        this._localSettings.setPageTitle(d.pageTitle);
      });
      this.route.queryParams.pipe(take(1)).subscribe(param => {
        if (param) {
          if (param['campaign']) {
            this._localSettings.setReferer(param['campaign']);
          }
          if (param['click_id']) {
            this._localSettings.setClickid(param['click_id']);
          }
        }
      });

      //-------- USER
      if (this.authenticationService.currentUserValue) {
        this.urlPrefix = '/';
        this.process = this.processService.getProcess('ACCOMMODATION');
        if (this.process) {
          this._subs$.push(this.sharedProcessService.updateProcessState('IN_PROGRESS', this.process).subscribe());
        }

        this.currentUser = this.userService.getInfos();
        if (this.currentUser.accommodationFavorites !== null && this.currentUser.accommodationFavorites !== '') {
          this.favList = this.currentUser.accommodationFavorites.split(',');
        }
      } else {
        this.currentUser = null;
        this.urlPrefix = '';
        if (localStorage && localStorage['tempFavorites']) {
          this.favList = JSON.parse(localStorage['tempFavorites']);
        }

      }

      this.school = this.schoolService.getCurrent();
      this.getStartingElements();
      this._subs$.push(this.tikTokService.sendPageView('URL List', this.router.url, this.currentUser ? this.currentUser.id : 0, 'page List'));
    }
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      mapboxgl as typeof mapboxgl;
      setTimeout(() => {
        this.map = new mapboxgl.Map({
          accessToken:
            'pk.eyJ1IjoiZG9vbWl0aCIsImEiOiJjbGx1dnRjdmYxN2diM2tvNzkwaGEyaWF2In0.iHZiLIVgE6wJyy_Q5NdR5g',
          container: 'map',
          style: this.style,
          zoom: 10,
          center: this.center,
        });
        this.map.dragRotate.disable();
        this.map.touchZoomRotate.disableRotation();

        this.map.addControl(new mapboxgl.NavigationControl({
          showCompass: false
        }), 'bottom-left');
        this.setSchoolMarker();
        // Sub aux event que quand la map est prête - je sais pas si on peut optimiser ou pas... (Gwen)
        this.map.once('idle', this._mapOnIdle$);
      }, 1);
      this.addScrollListener();
    }
  }

  ngOnDestroy(): void {
    if (this.platformService.isBrowserPlatform()) {
      if (this.isMobile && this.sideBar) {
        this.sideBar.classList.remove('down');
        this.sideBar.classList.remove('top');
      }
      if (this.map) {
        this.map.off('idle', this._mapOnIdle$);
        this.map.off('moveend', this._mapOnMoveEndZoomEnd$);
        this.map.off('zoomend', this._mapOnMoveEndZoomEnd$);
      }

      if (this._subs$ && this._subs$.length > 0) {
        this._subs$.forEach(s => {
          if (s) {
            s.unsubscribe();
          }
        });
      }
    }
  }

  public sortTrackBy(sort): number {
    return sort.id;
  }

  // Get all cities where LF has rooms
  public getStartingElements() {
    if (this.isBrowser) {
      this._subs$.push(this.schoolService.getStartingElements().pipe(first()).subscribe((data) => {
          this.startingCities = data.cities;
          this.startingSchools = data.schools;
          this.selectStartingElements();
          this.search = this.selectedStartingElement;
          if (this.selectedStartingElement && this.selectedStartingElement.type == 'school') {
            this.setInterestRooms(this.selectedStartingElement.latitude, this.selectedStartingElement.longitude, 1);
          } else {
            this.setRooms();
          }
        }
      ));
    }
  }

  public propertyTrackBy(index: number, property) {
    return property.id;
  }

  public doSort(event): void {
    this.sort = event;
    this.rooms.sort((a, b) => {
      switch (this.sort) {
        case 'priceAsc': {
          return a.property_price.price - b.property_price.price;
        }
        case 'priceDesc': {
          return b.property_price.price - a.property_price.price;
        }
        case 'newest': {
          return (new Date(b.created_at) as any) - (new Date(a.created_at) as any);
        }
        case 'disponibility_close': {
          return (new Date(a.disponibility) as any) - (new Date(b.disponibility) as any);
        }
        case 'disponibility_far': {
          return (new Date(b.disponibility) as any) - (new Date(a.disponibility) as any);
        }
        case 'promotion': {
          if (b.badges && b.badges.isPromoted == 1) {
            if (a.badges && a.badges.isPromoted == 1) {
              return a.property_price.price - b.property_price.price;
            }
            return 1;
          }
          return -1;
        }
        default: {
          return b.is_featured - a.is_featured;
        }
      }
    });

    this.displayedRooms = [];
    this.fetchMoreRooms('init');
  }

  private addScrollListener(): void {
    // Mobile & tablette
    if (this.innerWidth <= 991 && !this.document) {
      this.document = document.getElementById('sidenav-page_content');
      if (this.document) {
        // Test pour iOS
        // this.document.addEventListener('scroll', () => {
        //   this.touchMoveEvent();
        // });
        this.document.onscroll = () => this.touchMoveEvent();
      }
    } else {
      this.headerHeight = document.getElementById('top_header').offsetHeight;
      this.scrollDirection = 'top';
      this.isMapToggle = false;
      if (!this.sideBar) {
        this.sideBar = document.getElementsByClassName('sidebar')[0];
      }
      this.sideBar.classList.remove('d-none');
    }
  }

  public selectStartingElements() {
    if (!this.school || !this.startingCities || !this.startingSchools) {
      return;
    }
    let city;
    // Ville dans l'URL
    if (this.forceCity) {
      city = this.searchElement.toLowerCase();
    } else {
      // Ville de l'étudiant
      if (this.currentUser && this.currentUser.city) {
        city = this.currentUser.city;
      }
      // Ville de l'école
      else {
        if (this.school && this.school.city_id) {
          city = this.school.city_id;
        }
        // Ville par défaut
        else {
          city = 'Lille';
        }
      }
    }

    if (typeof city === 'string') {
      this.selectedStartingElement = this.startingCities.find(element => element.name.toLowerCase() == this.searchElement.toLowerCase());
      if (!this.selectedStartingElement) {
        this.selectedStartingElement = this.startingSchools.find(element => element.slug.toLowerCase() == this.searchElement.toLowerCase());
      }
    } else {
      this.selectedStartingElement = this.startingCities.find(element => element.id == this.school.city_id);
    }
    if (!this.selectedStartingElement) {
      this._subs$.push(this.accommodationService.getSearchElements(this.searchElement).subscribe(data => {
        if (data.cities) {
          this.selectedStartingElement = data.cities[0];
          this.setCenterAndZoom();
        }
      }));
    } else {
      this.setCenterAndZoom();
    }
  }

  public goToRoom(room) {
    if (this.currentUser) {
      this.hubspotService.updateHubspot({logement: room.partner_ref}).subscribe();
      this.userService.update({housingBudget: room.property_price.price}).subscribe();
      this.processService.createHousingLead(room.id, 'property').subscribe();
    }
    localStorage.setItem('city', this.searchElement);
    this.openRoomInNewTab(room);
  }

  private setCenterAndZoom(): void {
    this.search = this.selectedStartingElement;
    this.searchElement = this.selectedStartingElement.name;
    this.center = [this.selectedStartingElement.longitude, this.selectedStartingElement.latitude];
    if (this.map) {
      this.map.setCenter(this.center);
      if (this.selectedStartingElement.type === 'school') {
        this.map.setZoom(14);
      }
    }
  }

  public clickMarker(elementId, displayActiveCard: boolean = true) {
    let id;
    if (this.activeCard) {
      this.removeClass(this.activeCard.id, 'active');
    }

    if (elementId) {
      // CLic sur une room
      if (typeof elementId === 'number') {
        id = elementId;
        this.clickedRoomId = id;
      } // CLick sur la map
      else {
        id = elementId.id;
      }
      if (displayActiveCard) {
        this.activeCard = this.rooms.find(x => x.id == id);
      }

      if (!this.activeCard && this.noFilteredRooms) {
        this.activeCard = this.noFilteredRooms.find(x => x.id === id);
      }

      // Ajout d'une class déjà visité
      if (!this.hasBeenClicked.includes(id)) {
        this.hasBeenClicked.push(id);
        this.addClassToMarker('visited', id);
      }
      // Ajout d'une class active - remplace ChangeColor()
      this.addClassToMarker('active', id);
    }
  }

  public deleteMarkers() {
    this.tempMarkers.forEach(element => {
      element.remove();
    });
  }


  public checkItem(id) {
    if (id !== this.clickedRoomId) {
      this.clickedRoomId = null;
    }
  }

  public filteredRooms(e) {
    this.rooms = e[0];
    if (e[1]) {
      this.sort = e[1];
    }
    this.deleteMarkers();
    this.displayedRooms = [];
    this.noFilteredRooms = [];
    if (this.rooms && this.rooms.length < 80) {
      this.getSimilarRooms();
    } else {
      this.addMarkers(this.rooms);
      this.doSort(this.sort);
    }
  }

  public getFilters(event): void {
    this.filterFormModale = event;
  }

  public trigChangeCity(result?) {
    this.loading = true;
    this.allRooms = [];
    this.rooms = [];
    this.searchElement = this.helperService.slugify(result.name);
    this.changedCity = true;
    this.search = result;
    this.countProperties = null;
    this.center = [result.longitude, result.latitude];
    this.map.setCenter(this.center);
    // Reset le zoom
    this.map.setZoom(10);
    if (result.type !== 'city' && result.type !== 'metropole') {
      this.router.navigate(['/' +this.locale +'/accommodation/list/' + this.helperService.slugify(this.searchElement)], {
        relativeTo: this.route,
        replaceUrl: true
      });
      this.search = result;
      this.setInterestRooms(result.latitude, result.longitude, 1);
    } else {
      this.setRooms();
    }
  }

  /**
   * setTimeOut à garder (sauf si on trouve mieux) pour éviter que ça calcule trop et/ou fasse planter
   * @private
   */
  private touchMoveEvent(): void {
    if (this.innerWidth <= 991) {
      if (this.isMapToggle) {
        this.headerHeight = 0;
        this.scrollDirection = 'top';
      } else {
        const headerH = document.getElementById('top_header').offsetHeight;
        if (this.headerHeight !== headerH) {
          this.headerHeight = headerH;
        }
        if (!this.sideBar) {
          this.sideBar = document.getElementsByClassName('sidebar')[0];
        }

        let scroll = this.document.scrollTop;

        if (scroll > this.currentScroll) {
          this.scrollDirection = 'down';
          if (this.sideBar.classList.contains('top')) {
            this.sideBar.classList.remove('top');
          }

        } else if (scroll < this.currentScroll) {
          if (this.sideBar.classList.contains('down')) {
            this.sideBar.classList.remove('down');
          }
          this.scrollDirection = 'top';
        } else {
          if (scroll === 0) {
            if (this.sideBar.classList.contains('down')) {
              this.sideBar.classList.remove('down');
            }
            this.scrollDirection = 'top';
          }
        }
        this.sideBar.classList.add(this.scrollDirection);
        this.currentScroll = scroll;
      }

    }
    // format ordinateur
    else {
      this.scrollDirection = 'top';
    }
  }

  // Fournit des logements à displayedRooms pour les afficher
  public fetchMoreRooms(range: string, btn?): void {
    let index: number = 0;
    let end: number = 50;
    if (range === 'previous') {
      end = this.rooms.indexOf(this.displayedRooms[0]);
      index = end - 50;
    } else if (range === 'next') {
      index = this.rooms.indexOf(this.displayedRooms[this.displayedRooms.length - 1]) + 1;
      end = index + 50;
    }
    this.displayedRooms = this.rooms.slice(index ? index : 0, end);
    this.scrollTo('topScrollY');
    if (btn) {
      btn.blur();
    }
  }

  public doSearch(event): void {
    this.activeCard = null;
  }

  // Ajoute une class au marker
  public addClassToMarker(cssClass: string, id: number): void {
    const element = document.getElementById('m-' + id);
    if (element) {
      element.classList.add(cssClass);
    }
  }

  // Retire une class au marker
  public removeClass(id, cssClass): void {
    const element = document.getElementById('m-' + id);
    if (element) {
      element.classList.remove(cssClass);
    }
  }

  private getSimilarRooms(): void {
    this.noFilteredRooms = [];
    // Prix +/- 15%
    const minPrice: number = parseInt(this.filterFormModale['minPrice']) - parseInt(this.filterFormModale['minPrice']) * (15 / 100);
    const maxPrice: number = parseInt(this.filterFormModale['maxPrice']) + parseInt(this.filterFormModale['maxPrice']) * (15 / 100);
    // Surface +/- 15%
    const minMeter: number = parseInt(this.filterFormModale['minMeter']) - parseInt(this.filterFormModale['minMeter']) * (15 / 100);
    const maxMeter: number = parseInt(this.filterFormModale['maxMeter']) + parseInt(this.filterFormModale['maxMeter']) * (15 / 100);

    const firstFilter = {...this.filterFormModale};
    firstFilter.minPrice = minPrice ? Math.floor(minPrice) : 0;
    firstFilter.maxPrice = maxPrice ? Math.floor(maxPrice) : 10000;
    firstFilter.minMeter = minMeter ? Math.floor(minMeter) : 0;
    firstFilter.maxMeter = maxMeter ? Math.floor(maxMeter) : 10000;

    const largerArray = FunctionsUtil.filterRooms(this.allRooms, firstFilter);
    if (largerArray && largerArray.rooms.length > 0) {
      this.noFilteredRooms = largerArray.rooms;
    }

    // Même prix, même taille, même durée de location ; mais tout le reste différent
    if (this.noFilteredRooms && this.noFilteredRooms.length < 20) {
      const secondFilter = {...this.filterFormModale};
      secondFilter.bathrooms = null;
      secondFilter.wc = null;
      secondFilter.tenants = [];
      secondFilter.empty_rooms = [];
      secondFilter.tenants_gender = [];
      secondFilter.type = [];

      const differentArray = FunctionsUtil.filterRooms(this.allRooms, secondFilter);
      if (differentArray && differentArray.rooms.length > 0) {
        this.noFilteredRooms = [...new Set([...this.noFilteredRooms, ...differentArray.rooms])];
      }
    }

    if (this.rooms.length > 0 && this.noFilteredRooms.length > 0) {
      this.noFilteredRooms = this.noFilteredRooms.filter(r => !this.rooms.includes(r));
    }
    this.noFilteredRooms = this.noFilteredRooms.slice(0, 20);
    this.doSort(this.sort);
    this.addMarkers(this.rooms, this.noFilteredRooms);
  }


  private setRoom(data): void {
    const elementPartnerType = data.partner_type.replace(/\d+/g, '').toUpperCase().trim();
    if (elementPartnerType === 'CH' || elementPartnerType === 'ROOM_SHARED') {
      data.partner_type = 'room';
    }
    this.rooms.push(data);
  }

  public reloadSearchOnMap() {
    this.isMove = false;
    const north = this.map.getBounds().getNorth();
    const south = this.map.getBounds().getSouth();
    const east = this.map.getBounds().getEast();
    const west = this.map.getBounds().getWest();
    this.setRoomsFromMap(north, south, east, west);
  }

  private setRooms() {
    if (this.changedCity || this.router.url === this.currentLanguage+ '/accommodation/list') {
      if (document.getElementById('topScrollY')) {
        this.scrollTo('topScrollY');
        this.changedCity = false;
      }
      this.rooms = [];
      this.router.navigate(['/' + this.urlPrefix + this.currentLanguage+'/accommodation/list/' + this.helperService.slugify(this.searchElement)], {
        relativeTo: this.route,
        replaceUrl: true
      });
    }
    this.loading = true;
    const startingCity = this.startingCities.find(e => e.name === this.searchElement);
    if (startingCity) {
      this.center = [startingCity.longitude, startingCity.latitude];
      if (this.map) {
        this.map.setCenter(this.center);
      }
    }
    this.processService.getRooms(this.searchElement.toLowerCase(), null).pipe(
      finalize(() => {
        this.loading = false;
      })
    ).subscribe((resp) => {
      this.setDatas(resp);
      this.deleteMarkers();
      this.addMarkers(this.rooms);
    });
  }

  private setInterestRooms(latitude, longitude, distance) {
    this.loading = true;
    this.processService.getRoomsFromInterest(latitude, longitude, distance).pipe(
      finalize(() => {
        this.loading = false;
      })
    ).subscribe((resp) => {
      this.setDatas(resp);
      this.deleteMarkers();
      this.addMarkers(this.rooms);
      this.setInterestMarker();
      this.map.setZoom(14);
    });
  }

  private setRoomsFromMap(north, south, east, west) {
    this.searchFrom = 'map';
    this.loading = true;
    this.processService.getRoomsFromGeoloc(north, south, east, west).pipe(
      finalize(() => {
        this.loading = false;
      })
    ).subscribe((resp) => {
      this.setDatas(resp);
      this.deleteMarkers();
      this.addMarkers(this.rooms);
    });
  }


  // MAP
  private _mapOnMoveEndZoomEnd$ = () => {
    if (this.isSearchOnMove) {
      const north = this.map.getBounds().getNorth();
      const south = this.map.getBounds().getSouth();
      const east = this.map.getBounds().getEast();
      const west = this.map.getBounds().getWest();
      this.setRoomsFromMap(north, south, east, west);
    } else {
      this.isMove = true;
    }
  };

  private _mapOnIdle$ = () => {
    this.map.on('moveend', this._mapOnMoveEndZoomEnd$);
    this.map.on('zoomend', this._mapOnMoveEndZoomEnd$);
  };

  private setSchoolMarker() {
    if (this.currentUser != null && this.currentUser.faculty && this.currentUser.faculty.id && (this.currentUser.faculty.latitude || this.currentUser.faculty.longitude)) {
      if (this.currentUser.faculty.latitude != null && this.currentUser.faculty.longitude != null) {
        this.schoolMarker.position = {
          lat: parseFloat(this.currentUser.faculty.latitude),
          lng: parseFloat(this.currentUser.faculty.longitude),
        };
      } else {
        this.schoolMarker.position = {
          lat: parseFloat(this.school.latitude),
          lng: parseFloat(this.school.longitude),
        };
      }
    } else {
      this.schoolMarker.position = {
        lat: parseFloat(this.school.latitude),
        lng: parseFloat(this.school.longitude),
      };
    }

    const el = document.createElement('div');
    el.className = 'markerS';
    new mapboxgl.Marker(el).setLngLat([this.schoolMarker.position.lng, this.schoolMarker.position.lat]).addTo(this.map);

  }

  public unactiveCard(id): void {
    this.removeClass(id, 'active');
    this.activeCard = null;
  }

  private openRoomInNewTab(room) {
    const metropole = room.property_address.metropole ? room.property_address.metropole.toLowerCase() + '/' : '';
    window.open(this.router.serializeUrl(this.router.createUrlTree([this.currentLanguage + '/accommodation/' + metropole + 'property/' + room.id])), '_blank');
  }

  // mobile
  toggleMenu(value) {
    const k = document.getElementsByClassName('sidebar');
    if (k[0]) {
      if (!this.isMapToggle) {
        this.headerHeight = 0;
        k[0].classList.add('d-none');
      } else {
        k[0].classList.remove('d-none');
      }
    }
    this.isMapToggle = value != 'left';
    this.desktopMapConfig(false);
  }


  /**
   * Change la configuration de la page selon si l'utilisateur veut map only ou map avec liste de logement
   * @param event
   */
  public desktopMapConfig(event: boolean): void {
    this.isMapOnly = event;
    setTimeout(() => {
      this.map.resize();
    }, this.innerWidth <= 991 ? 250 : 1);

  }


  private addMarkers(rooms, secondRooms?) {
    this.tempMarkers.forEach(marker => {
      marker.remove();
    });

    this.geoJson = {
      'type': 'FeatureCollection',
      'features': []
    };
    if (rooms && rooms.length > 0) {
      rooms.forEach(element => {
        if (element.property_address.listLatitude) {
          this.geoJson.features.push({
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [element.property_address.listLongitude, element.property_address.listLatitude]
            },
            'properties': {
              'title': element.id,
              'description': Math.ceil(element.property_price.price),
              'badges': element.badges
            }
          });
        }
      });
    }
    if (secondRooms && secondRooms.length > 0) {
      secondRooms.forEach(element => {
        if (element.property_address.listLatitude) {
          const hasBadge = element.badges && (
            element.badges.isLocated == 1 ||
            element.badges.isPopular == 1 ||
            element.badges.isPromoted == 1
          );
          let marker = {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [element.property_address.listLongitude, element.property_address.listLatitude]
            },
            'properties': {
              'title': element.id,
              'description': Math.ceil(element.property_price.price),
              'isSimilar': true,
            }
          };
          if (hasBadge) {
            marker.properties['badges'] = element.badges;
          }
          this.geoJson.features.push(marker);
        }
      });
    }

    if (this.map) {
      this._zoomLevel = this.map.getZoom();
      this._maxMarkers = this.getMaxMarkersPerZoomLevel(this._zoomLevel);
      this.markersOnMap = this.geoJson.features.slice(0, this._maxMarkers);
      this.markersOnMap.forEach(feature => {
        const el = document.createElement('div');
        el.className = 'marker';
        el.id = 'm-' + feature.properties.title;
        el.innerHTML = '<span>' + feature.properties.description + ' €</span>';
        if (this.favList.includes(feature.properties.title.toString())) {
          el.className += ' favorite';
        }

        const hasBadge = feature.properties.badges && (
          feature.properties.badges.isLocated == 1 ||
          feature.properties.badges.isPopular == 1 ||
          feature.properties.badges.isPromoted == 1
        );
        if (feature.properties.badges && hasBadge) {
          let b;
          if (typeof feature.properties.badges == 'string') {
            b = JSON.parse(feature.properties.badges);
          } else {
            b = feature.properties.badges;
          }

          if (b.isLocated) {
            el.className += ' localisation';
          } else if (b.isPopular) {
            el.className += ' popular';
          } else {
            el.className += ' promotion';
          }
        }

        if (feature.properties.isSimilar) {
          el.className += ' isSimilar';
        }

        el.addEventListener('click', () => {
          this.clickMarker(feature.properties.title);
        });

        const s = new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(this.map);
        this.tempMarkers.push(s);
      });
    }
  }

  private getMaxMarkersPerZoomLevel(zoomLevel) {
    if (zoomLevel <= 5) {
      return 5;
    } else if (zoomLevel <= 7) {
      return 20;
    } else if (zoomLevel <= 10) {
      return 200;
    } else {
      return 500;
    }
  }

  private setDatas(resp): void {
    this.loadedOnce = true;
    this.displayedRooms = [];
    let data = resp.properties;
    if (this.currentUser) {
      if (data.length > 1) {
        let hubspotDatas = {};
        let property;
        if (data[0] && data[0].property_address && data[0].property_address.city_group) {
          property = data[0];
        } else {
          property = data.find(d => d.property_address.city_group !== null);
        }
        if (property && property.property_address && property.property_address.city_group) {
          this.userService.getCityById(property.property_address.city_group).subscribe((city: any) => {
            if (this.currentUser.school_id === 53) {
              this.hubspotService.updateHubspot({
                studies_city: city.name,
              }).subscribe();
            }
            hubspotDatas = {
              city: city.name,
              campagne: '',
              source: '',
              medium: ''
            };

            hubspotDatas = this.helperService.setUtmToHubspot(hubspotDatas);
            this._subs$.push(this.userService.setHubspotDeal(3321704, 11561519, hubspotDatas).pipe(take(1)).subscribe());
          });
        }
      }
    }
    data = data.filter(p => p.disponibility);
    this.countProperties = data.length;
    this.allRooms = data;
    this.rooms = [];
    this.allRooms.forEach(element => {
      element = FunctionsUtil.setMinimumResa(element);
      this.setRoom(element);
    });
    if (this.filterFormModale) {
      this.rooms = FunctionsUtil.filterRooms(this.allRooms, this.filterFormModale).rooms;
    }
    this.fetchMoreRooms('init');

  }

  public changeFavorite(id): void {
    const element = document.getElementById('m-' + id);
    if (element) {
      if (element.classList.contains('favorite')) {
        element.classList.remove('favorite');
      } else {
        element.classList.add('favorite');
      }
    }
  }

  private setInterestMarker() {
    if (this.currentIMarker) {
      this.currentIMarker.remove();
    }
    this.interestMarker = {position: {lat: 0, lng: 0}};
    this.interestMarker.position = {
      lat: parseFloat(this.search.latitude),
      lng: parseFloat(this.search.longitude),
    };

    const el = document.createElement('div');
    el.className = 'markerI';
    this.currentIMarker = new mapboxgl.Marker(el).setLngLat([this.interestMarker.position.lng, this.interestMarker.position.lat]).addTo(this.map);

  }

  // Utilisé pour scroll au top quand on change de ville
  private scrollTo(selector): void {
    const k = document.getElementById(selector);
    //TODO : améliorer (timeout pas usefull)
    if (k) {
      k.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
      setTimeout(() => {
        k.focus();
      }, 500);
    }
  }




}
